module.exports = __webpack_public_path__ + "img/logo-gif-global-corporate.b4da85c2.gif";